enum DeviceTypeEnum {
  DESKTOP = "desktop",
  MOBILE = "mobile"
}

export default DeviceTypeEnum;